import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../common/icons/PhonePlan-Icon.svg'
import _imports_1 from '../common/icons/AKKOPlan-Icon.svg'


_pushScopeId("data-v-7065e2a0")
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-3 card mb-3 p-4"
}
const _hoisted_2 = {
  key: 0,
  class: "form-container rounded p-4"
}
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-0 cera-med" }, "Select Your Device", -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_7 = { class: "d-flex gap-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center justify-content-around" }, [
  /*#__PURE__*/_createElementVNode("img", {
    height: "70",
    width: "70",
    alt: "Phone Plan",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0 mt-1 cera-med al-center-mobile" }, "Phone Plan")
], -1)
const _hoisted_9 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_10 = { class: "d-flex flex-row mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "\n                  d-flex\n                  align-items-center\n                  justify-content-center\n                  select-label\n                  fs-7\n                  p-2\n                ",
  style: {"min-width":"56px"}
}, " Make ", -1)
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", {
  value: "null",
  selected: "",
  disabled: ""
}, "Select Make", -1)
const _hoisted_14 = { class: "d-flex flex-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "\n                  d-flex\n                  align-items-center\n                  justify-content-center\n                  select-label\n                  fs-7\n                  p-2\n                " }, " Model ", -1)
const _hoisted_16 = ["onChange"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: "",
  disabled: ""
}, "Select Model", -1)
const _hoisted_18 = {
  key: 1,
  class: "form-container rounded p-4"
}
const _hoisted_19 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h6", { class: "mb-0" }, "Select Your Plan", -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Remove ")
const _hoisted_23 = { class: "d-flex gap-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column align-items-center justify-content-around" }, [
  /*#__PURE__*/_createElementVNode("img", {
    height: "70",
    width: "70",
    alt: "Phone Plan",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("h6", { class: "mb-0 mt-1 nowrap cera-med al-center-mobile" }, " AKKO Plan ")
], -1)
const _hoisted_25 = { class: "d-flex flex-column flex-grow-1 justify-content-center" }
const _hoisted_26 = { class: "d-flex flex-row mb-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "\n                  d-flex\n                  align-items-center\n                  justify-content-center\n                  select-label\n                  fs-7\n                  p-2\n                ",
  style: {"min-width":"56px"}
}, " Plan ", -1)
const _hoisted_28 = ["onUpdate:modelValue", "onChange"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", {
  value: "null",
  selected: "",
  disabled: ""
}, "Select Plan", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: 'ADULT' }, "Adult", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: 'STUDENT' }, "Student", -1)
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = ["onUpdate:modelValue", "onChange"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", {
  value: "null",
  selected: "",
  disabled: ""
}, "Select Plan", -1)
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["value"]
const _hoisted_38 = ["value"]
const _hoisted_39 = {
  key: 1,
  class: "d-flex flex-column align-items-center bg-white card p-4 gap-4"
}
const _hoisted_40 = {
  key: 2,
  class: "row"
}
const _hoisted_41 = { class: "col-12 mb-2" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanInfo = _resolveComponent("PlanInfo")!
  const _component_CloseIcon = _resolveComponent("CloseIcon")!
  const _component_PlanSelect = _resolveComponent("PlanSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (Object.keys(_ctx.coverageCombo.selectionMap.selections).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", null, [
            (!_ctx.isInjuredGadgets)
              ? (_openBlock(), _createBlock(_component_PlanInfo, {
                  key: 0,
                  type: _ctx.coverageCombo.coverageType,
                  open: ""
                }, null, 8, ["type"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverageCombo.selectionMap.selections, (selection, key) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              (selection.type === 'phone')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.coverageCombo.removeSelection(key)),
                        class: "\n              px-25\n              py-1\n              btn btn-primary\n              inter\n              btn-mobile\n              w-100-mobile\n              fw-600\n              ml-auto\n              d-flex\n              align-items-center\n              fs-65\n            "
                      }, [
                        _createVNode(_component_CloseIcon, { class: "pointer close-icon" }),
                        _hoisted_6
                      ], 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _hoisted_11,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": ($event: any) => (selection.detail.maker = $event),
                            class: _normalizeClass([selection.detail.maker === null ? '' : 'black', "form-select p-2 fs-7 select"])
                          }, [
                            _hoisted_13,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverageCombo.phoneMakers, (maker) => {
                              return (_openBlock(), _createElementBlock("option", { key: maker }, _toDisplayString(maker), 1))
                            }), 128))
                          ], 10, _hoisted_12), [
                            [_vModelSelect, selection.detail.maker]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("select", {
                            class: _normalizeClass(["form-select p-2 fs-7 select", selection.detail.model === null ? '' : 'black']),
                            onChange: ($event: any) => (
                  _ctx.coverageCombo.registerDeviceSelection($event, selection)
                )
                          }, [
                            _hoisted_17,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coverageCombo.phoneModels(
                    selection.detail.maker,
                  ), (model) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "black",
                                key: model
                              }, _toDisplayString(model), 1))
                            }), 128))
                          ], 42, _hoisted_16)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (selection.type === _ctx.CoverageType.AKKO)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.coverageCombo.removeSelection(key)),
                        class: "\n              px-25\n              py-1\n              btn btn-primary\n              inter\n              btn-mobile\n              w-100-mobile\n              fw-600\n              ml-auto\n              d-flex\n              align-items-center\n              fs-65\n            "
                      }, [
                        _createVNode(_component_CloseIcon, { class: "pointer close-icon" }),
                        _hoisted_22
                      ], 8, _hoisted_21)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _withDirectives(_createElementVNode("select", {
                            class: _normalizeClass(["form-select p-2 fs-7 select", selection.detail.type === null ? '' : 'black']),
                            "onUpdate:modelValue": ($event: any) => (selection.detail.type = $event),
                            onChange: ($event: any) => (
                  _ctx.coverageCombo.registerAkkoPlanTypeSelection($event, selection)
                )
                          }, _hoisted_32, 42, _hoisted_28), [
                            [_vModelSelect, selection.detail.type]
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (
          selection.type === 'injuredgadgets' &&
          _ctx.coverages &&
          _ctx.coverages.length > 0
        )
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 2,
                    class: "form-select mb-3",
                    "onUpdate:modelValue": ($event: any) => (selection.detail.type = $event),
                    onChange: ($event: any) => (
            _ctx.coverageCombo.registerInjureGadgetPlanTypeSelection(
              $event,
              selection,
            )
          )
                  }, [
                    _hoisted_34,
                    (_ctx.planPhoneIGCoverage)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 0,
                          value: _ctx.InjuredGadgetsCoverageType.PLAN_PHONE
                        }, _toDisplayString(_ctx.getDisplayName(_ctx.planPhoneIGCoverage)), 9, _hoisted_35))
                      : _createCommentVNode("", true),
                    (_ctx.planFoldablePhoneIGCoverage)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 1,
                          value: _ctx.InjuredGadgetsCoverageType.PLAN_FOLDABLE_PHONE
                        }, _toDisplayString(_ctx.getDisplayName(_ctx.planFoldablePhoneIGCoverage)), 9, _hoisted_36))
                      : _createCommentVNode("", true),
                    (_ctx.planBundledIGCoverage)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 2,
                          value: _ctx.InjuredGadgetsCoverageType.PLAN_BUNDLED
                        }, _toDisplayString(_ctx.getDisplayName(_ctx.planBundledIGCoverage)), 9, _hoisted_37))
                      : _createCommentVNode("", true),
                    (_ctx.planBundledProIGCoverage)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 3,
                          value: _ctx.InjuredGadgetsCoverageType.PLAN_PRO
                        }, _toDisplayString(_ctx.getDisplayName(_ctx.planBundledProIGCoverage)), 9, _hoisted_38))
                      : _createCommentVNode("", true)
                  ], 40, _hoisted_33)), [
                    [_vModelSelect, selection.detail.type]
                  ])
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.partnerProgram === _ctx.PartnerPrograms.AKKO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
          (
        (_ctx.isCoverageType(null) || _ctx.isCoverageType(_ctx.CoverageType.phone)) &&
        _ctx.hasPartnerSalesRegisterPlanPhonePlansPermission
      )
            ? (_openBlock(), _createBlock(_component_PlanSelect, {
                key: 0,
                another: _ctx.isCoverageType(_ctx.CoverageType.phone),
                type: _ctx.CoverageType.phone,
                btnClick: () => _ctx.addPhonePlan()
              }, null, 8, ["another", "type", "btnClick"]))
            : _createCommentVNode("", true),
          (
        (_ctx.isCoverageType(null) || _ctx.isCoverageType(_ctx.CoverageType.AKKO)) &&
        _ctx.hasPartnerSalesRegisterPlanAkkoPlansPermission
      )
            ? (_openBlock(), _createBlock(_component_PlanSelect, {
                key: 1,
                another: _ctx.isCoverageType(_ctx.CoverageType.AKKO),
                type: _ctx.CoverageType.AKKO,
                btnClick: () => _ctx.addAkkoPlan()
              }, null, 8, ["another", "type", "btnClick"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.partnerProgram === 'injuredgadgets')
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.coverageCombo.addInjuredGadgetsPlan(_ctx.planInterval))),
              class: "btn btn-fw btn-primary"
            }, " Add Plan ")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}